export const setupAchPayment = async (stripe, clientSecret, billingDetails) => {
  const collected = await stripe.collectBankAccountForSetup({
    clientSecret,
    params: {
      payment_method_type: 'us_bank_account',
      payment_method_data: {
        billing_details: billingDetails,
      },
    },
  });

  if (collected.error) {
    throw new Error(collected.error.message);
  }

  if (collected.setupIntent.status === 'requires_payment_method') {
    throw new Error(
      'Bank account verification was canceled. Choose a bank account or pay by card.'
    );
  }

  if (collected.setupIntent.status === 'succeeded') {
    return collected.setupIntent;
  }

  if (collected.setupIntent.status !== 'requires_confirmation') {
    throw new Error(
      'This bank account could not be verified instantly. Choose another bank account or pay by card.'
    );
  }

  const confirmed = await stripe.confirmUsBankAccountSetup(clientSecret);

  if (confirmed.error) {
    throw new Error(confirmed.error.message);
  }

  if (confirmed.setupIntent.status !== 'succeeded') {
    throw new Error(
      'This bank account could not be verified instantly. Choose another bank account or pay by card.'
    );
  }

  return confirmed.setupIntent;
};
